module.exports = __webpack_public_path__ + "img/87.f8d7ac3.png";